var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test common_content"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"xs":24,"sm":24,"md":24}},[_c('search',{attrs:{"showHide":false,"role":1}}),_c('test-index'),_c('p',{staticClass:"common_text_line common_content"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }